module.exports = __webpack_public_path__ + "img/3_cobe.d68424ba.jpg";